<template>
    <div class="i-array-editor" v-if="show">
        <ilabel :label="label" :required="required" v-if="label" />
        <btn l='Редактировать' @press="openModal('i-array-edit-table-modal-'+ido)" s="m" i='pencil'/>
        <modal :name="`i-array-edit-table-modal-${ido}`" :title="label">
            <table border="1">
                <thead>
                    <tr>
                        <td v-for="label in labels(scheme)" >{{label}} </td>
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,idx) in data">
                        <td>{{idx+1}}</td>
                        <td v-for="path in fields(scheme)" :style="{width:(scheme[path].type=='image'?'120px':'auto')}">
                            <i-multi-view  :config="scheme[path]" :value="getByPath(path,idx)" />
                        </td>
                        <td>
                            <btn i="pencil" @press="edit(idx)"  />
                            <btn i="chevron-up" @press="move(idx,idx-1)" :disabled="idx==0" />
                            <btn i="chevron-down" @press="move(idx,idx+1)" :disabled="idx==data.length-1" />
                            <btn i="trash" t='d' @press="remove(idx)" />
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="footer" slot="footer">
                <btn label="Добавить элемент" @press="add" t="p" pull='left' s='m' i='plus'/>
                <btn label="Закрыть" @press="close" t="df"  s='m' i='times'/>
                <btn label="Сохранить" @press="save" t="s"  s='m' i='save'/>
            </div>
        </modal>
        <i-modal-form 
            :name="`i-array-edit-${ido}`" 
            :widescreen="true" padding="8" 
            :title="label" 
            :scheme="scheme" 
            :value="current"
            @input="onCurrentSave"
        />
    </div>
</template>
<script>
import _ from "lodash";
import iMultiView from "./i-multi-view.vue"
export default {
    components: { iMultiView },
    methods: {
        onCurrentSave(item){
            this.data[this.currentIdx] = Object.assign({},this.data[this.currentIdx],item);
            this.data.__ob__.dep.notify();
            this.$emit('input', this.data);
        },
        opnModal() {
            this.opened = true;
            let { ido } = this;
            this.openModal(`i-array-edit-${ido}-modal`);
        },close(){

            let {data,ido} = this;
            this.closeModal(`i-array-edit-table-modal-${ido}`);
        },
        save(){
            let {data,ido} = this;
            this.$emit('input', data);
            this.closeModal(`i-array-edit-table-modal-${ido}`);
        },
        edit(idx){
            let { ido } = this;
            this.currentIdx = idx;
            this.current = this.data[idx];
            this.openModal(`i-array-edit-${ido}-modal`);

        },
        add(a) {
            if (a === -1) {
                this.data.unshift({});
            } else {
                this.data.push({});
            }
        },
        labels(scheme) {
            return Object.keys(scheme).reduce((ns, s) => {
                if (scheme[s].index) ns[scheme[s].index] = scheme[s].label;
                return ns;
            }, []);
        },
        fields(scheme, item) {
            let data = Object.keys(scheme).reduce((ns, s) => {
                if (scheme[s].index) ns[scheme[s].index] = s;
                else ns.push(s);
                return ns;
            }, []);
            return data.filter(function(element) {
                return !!element ;
            });
        },
        remove(idx) {
            let self = this;
            let data = _i.clone(this.data);
            data.splice(idx, 1);

            setTimeout(() => {
                self.data = data;
                self.rerender();

            }, 1);
            this.$emit('input', data);
        },
        move(old, nw) {
            let data = _i.clone(this.data);
            if (nw >= data.length) {
                var k = nw - data.length + 1;
                while (k--) {
                    data.push(undefined);
                }
            }
            data.splice(nw, 0, data.splice(old, 1)[0]);

            let ad = data;
            this.data = [];
            let self = this;
            setTimeout(() => {
                self.data = ad;
                self.rerender();
            }, 100);


            this.$emit('input', data);
        },
        getByPath(path, i) {
            let { data, scheme } = this;
            let splittedPath = path.split('.');
            let lastEl = splittedPath[splittedPath.length - 1];
            return splittedPath.reduce((ns, p) => {
                if (!ns) {
                    ns = {};
                }
                if (!ns[p]) {
                    if (p !== lastEl) ns[p] = {};
                }
                return ns[p];
            }, data[i]);
        },
        setByPath(path, value, i) {
            let splittedPath = path.split('.');
            let { data } = this;
            let self = this;
            self.changed = true;
            splittedPath.reduce((ns, p, i) => {
                if (i === splittedPath.length - 1) {
                    ns[p] = value;
                } else return ns[p];
            }, data[i]);
            this.$emit('input', data);
        },
    },
    mounted() {
        this.data = this.value;
    },
    watch: {
        value(dt) {
            this.data = dt;
        }
    },
    name: 'i-array-editor',
    props: {
        label: { type: String },
        //mode: { type: String, default: "sort" },
        value: { type: [Array, iFormData], default () { return [] } },
        scheme: { type: Object },
        mode: { type: String, default: 'h' },
        required: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            show: true,
            ido: _.random(0, 99999999),
            data: [],
            opened: false,
            current: {}
        }
    }
}
</script>
<style lang="css" scoped>
.i-array-editor table {
    width: 100%;
}

table {
    border-collapse: collapse;
    border-color: lightgrey;
    border: none;
}

td {
    padding: 4px 8px;
}

tr td:last-child {
    max-width: 50px;
}

table thead {
    font-weight: bold;
    background: whitesmoke;
}
</style>